import {
  ApolloClient,
  createHttpLink,
  InMemoryCache,
  from
} from '@apollo/client';
import { authLink } from './authLink';
import { errorLink } from './errorLink';

const httpLink = createHttpLink({
  uri: /localhost$/.test(location.hostname)
    ? '/graphql'
    : `${process.env.REACT_APP_BACKEND_API_BASE_URL}/graphql`
});

const pusherLink = createHttpLink({
  uri: /localhost$/.test(location.hostname)
    ? '/pusher/learner-auth'
    : `${process.env.REACT_APP_BACKEND_API_BASE_URL}/pusher/learner-auth`
});

export const client = new ApolloClient({
  link: from([errorLink, authLink, httpLink, pusherLink]),
  cache: new InMemoryCache({
    typePolicies: {
      VideoMedium: {
        // The same video can be reused across multiple sequences, but its
        // per-sequence learner progress (`videoRecord.watchedSeconds`) differs
        // between them. Normalizing VideoMedium by `id` makes it a single shared
        // cache entity, so prefetching the next sequence overwrites the current
        // sequence's `videoRecord` (e.g. 58s -> 14s) and breaks "resume from".
        // Storing VideoMedium inline under its parent item keeps each
        // sequence's progress isolated.
        keyFields: false
      }
    }
  })
});
